import React, { useEffect, useState } from "react";
import DOMPurify from "dompurify";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { db } from "../../firebase";
import './Veranstaltungen.css';

const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    return date.toLocaleDateString("de-DE", { weekday: "long", day: "2-digit", month: "long", year: "numeric" });
};

const Veranstaltungen = () => {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getDocs(query(collection(db, "events"), orderBy("date", "asc")))
            .then((snapshot) => {
                setEvents(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
            })
            .catch(console.error)
            .finally(() => setLoading(false));
    }, []);

    return (
        <div className="veranstaltungen-section">
            <div className="veranstaltungen-header">
                <span className="label-sub">Termine</span>
                <h1>Veranstaltungen</h1>
            </div>
            {loading
                ? <p className="veranstaltungen-empty">Veranstaltungen werden geladen…</p>
                : events.length === 0
                    ? <p className="veranstaltungen-empty">Aktuell sind keine Veranstaltungen geplant.</p>
                    : (
                        <div className="veranstaltungen-list">
                            {events.map((event) => (
                                <div className="veranstaltung-card" key={event.id}>
                                    {event.image?.url && (
                                        <img className="veranstaltung-image" src={event.image.url} alt={event.image.alt || event.title} />
                                    )}
                                    <div className="veranstaltung-date">{formatDate(event.date)}{event.time ? `, ${event.time}` : ''}</div>
                                    <h3 className="veranstaltung-title">{event.title}</h3>
                                    {event.subtitle && <div className="veranstaltung-subtitle">{event.subtitle}</div>}
                                    {event.location && <div className="veranstaltung-location">{event.location}</div>}
                                    {event.bodyHtml && (
                                        <div
                                            className="veranstaltung-description"
                                            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(event.bodyHtml) }}
                                        />
                                    )}
                                    {event.price && <p className="veranstaltung-price">{event.price}</p>}
                                    {event.contact && <p className="veranstaltung-contact">{event.contact}</p>}
                                </div>
                            ))}
                        </div>
                    )
            }
        </div>
    );
};

export default Veranstaltungen;
